import {
  Component,
  HostListener,
  Inject,
  Input, OnInit, PLATFORM_ID
} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {
  REGISTER_TO_RACE
} from "src/app/app-routing.module";
import {AbstractComponent} from "../abstract.component";
import {EventItem, Lookups, Race, RaceCommercialItem, RaceRoute, Waypoint} from "@model";
import {RaceCommercialService, RaceRouteService, RaceService, WaypointService} from "@services";
import {isPlatformBrowser} from "@angular/common";
import {TranslocoService} from "@ngneat/transloco";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {RaceDetailsModalComponent} from "../race-details-modal/race-details-modal.component";

@Component({
  selector: 'app-race-grid-item',
  templateUrl: './race-grid-item.component.html',
  styleUrls: ['./race-grid-item.component.scss']
})
export class RaceGridItemComponent extends AbstractComponent implements OnInit {
  @Input() race: Race | undefined;
  @Input() eventItem: EventItem | undefined;
  @Input() itemClass: string | undefined;
  @Input() logoPath: string | undefined;
  @Input() isLast: boolean = false;
  @Input({required: true}) languages: Lookups[] = [];
  @Input() countries: Lookups[] = [];
  @Input() currencyLabel: string | undefined;
  @Input() hideRegistration: boolean = false;

  waypointList: Waypoint[] = [];
  raceCommercialItems?: RaceCommercialItem[];
  raceRoute: RaceRoute | undefined;

  currentWindowWidth: number = 0;

  constructor(private raceService: RaceService, private router: Router,
              private route: ActivatedRoute, @Inject(PLATFORM_ID) private platformId: Object,
              public translocoService: TranslocoService, private modalService: NgbModal,
              public waypointService:WaypointService, private raceCommercialService: RaceCommercialService,
              private raceRouteService: RaceRouteService) {
    super();
    if (isPlatformBrowser(this.platformId)) {
      this.currentWindowWidth = window.innerWidth;
    }
  }

  ngOnInit(): void {
    this.waypointService.findWaypoints(this.race?.id).subscribe((value)=>{
      this.waypointList = value;
    });
    this.raceCommercialService.findRaceCommercialItems(this.race!.id!).subscribe(value => {
      this.raceCommercialItems = value;
    });
    this.raceRouteService.fetchRaceRoute(this.race!.id!).subscribe(value=> {
      this.raceRoute = value;
    });
  }


  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.currentWindowWidth = event.target.innerWidth;
  }


  onRegister(): void {
    if (this.race && !this.hideRegistration) {
      if (this.race.raceSettings?.registrationExternalUrl) {
        window.open(this.race.raceSettings.registrationExternalUrl);
      } else {
        this.router.navigate([REGISTER_TO_RACE], {
          relativeTo: this.route,
          queryParamsHandling: "merge",
          queryParams: {
            eventId: this.race.eventId,
            raceId: this.race.id
          },
        });
      }
    }
  }

  onMore(): void {
    if (this.race && this.eventItem) {
      this.raceService.setCurrentRace(this.race);
      const titleKey = 'app.common.details';
      this.openRaceDetailsModal(titleKey, this.race, this.eventItem);
    }
  }

  private openRaceDetailsModal(titleKey: string, race: Race, eventItem: EventItem) {
    const modalRef: NgbModalRef = this.modalService.open(RaceDetailsModalComponent, {
      centered: true,
      windowClass: 'race-details-modal'
    });
    modalRef.componentInstance.title = this.translocoService.translate(titleKey);
    modalRef.componentInstance.languages = this.languages;
    modalRef.componentInstance.countries = this.countries;
    modalRef.componentInstance.currencyLabel = this.currencyLabel;
    modalRef.componentInstance.race = race;
    modalRef.componentInstance.eventItem = eventItem;
    modalRef.componentInstance.waypointList = this.waypointList;
    modalRef.componentInstance.raceCommercialItems = this.raceCommercialItems;
  }
}
